module.exports = __webpack_public_path__ + "static/media/kingOfCapot-2.11c01bec.png";